import React from 'react';
import { useTranslation } from 'react-i18next';

import translations from 'services/translations/translations';

import RichOfferTextEditor from './RichOfferTextEditor';

const OfferText = ({
  locked,
  offerText,
  onOfferTextChanged,
}: {
  locked: boolean;
  offerText: string;
  onOfferTextChanged: (value: string) => void;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);

  return (
    <RichOfferTextEditor
      disabled={locked}
      label={t(`${translations.calculationWindow}:Offer text`)}
      onChange={onOfferTextChanged}
      value={offerText}
    />
  );
};

export default OfferText;
